import React from 'react'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'
import { useParams } from 'react-router'
import { Grid } from '@mui/material'
import { shallowEqual, useSelector } from 'react-redux'
import DevelopmentApp from 'inDevelop/components/DevelopmentApp'

const RpqsStatisticsApp = () => {
    const {
        rpqs,
    } = useSelector(store => ({
        rpqs: store.RpqsReducer.rpqs,
    }), shallowEqual)

    const { annee, idCollectivite } = useParams()

    useTitle(() => [{
        title: 'RPQS',
        href: 'rpqs',
    }, {
        title: rpqs.year || `${i18n.year} ${i18n.unknown}`,
        href: `rpqs/${annee}/collectivite/${idCollectivite}`,
    }, {
        title: rpqs.name || i18n.unknown,
        href: `rpqs/${annee}/collectivite/${idCollectivite}`,
    }, {
        title: i18n.statistics,
        href: `rpqs/${annee}/collectivite/${idCollectivite}/statistics`,
    }], [rpqs, annee, idCollectivite])

    return (
        <Grid sx={{ padding: 1 }}>
            <DevelopmentApp />
        </Grid>
    )
}

export default RpqsStatisticsApp
